export const Welcome = () => {
  return (
    <section className="Welcome">
      <h1 className="HeaderOne">
        I’m Talha, a{" "}
        <span style={{ color: "var(--accent-blue)" }}>
          Full Stack Software Engineer
        </span>{" "}
        based in New Jersey with 2 years of experience.{"\n"}I build and
        modernize web applications, and I’m passionate about creating clean,
        reusable, and maintainable code that stands the test of time. Building
        software that serves people well gives me a deep sense of fulfillment.
      </h1>
    </section>
  );
};
